import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { ValueProp } from './components/ValueProp';
import { CaseCollection } from './components/CaseCollection';
import { CasePages } from './components/CasePages';
import { BundleHighlight } from './components/BundleHighlight';
import { Suspects } from './components/Suspects';
import { HowItWorks } from './components/HowItWorks';
import { Testimonials } from './components/Testimonials';
import { IncludedFeatures } from './components/IncludedFeatures';
import { ForYouNotForYou } from './components/ForYouNotForYou';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="relative w-full min-h-screen bg-[#0a0a0a] selection:bg-[#8b1a1a] selection:text-[#ece3d0]" data-id="element-0">
      {/* Global Ambient Noise & Vignette */}
      <div className="pointer-events-none fixed inset-0 z-[100] mix-blend-overlay opacity-[0.15] bg-noise" data-id="element-1" />
      <div className="pointer-events-none fixed inset-0 z-[99] bg-[radial-gradient(circle_at_center,transparent_30%,rgba(10,10,10,0.5)_100%)]" data-id="element-2" />

      <div className="relative z-0" data-id="element-3">
        <Nav data-id="element-4" />
        <Hero data-id="element-5" />
        <ValueProp data-id="element-6" />
        <CaseCollection data-id="element-7" />
        <CasePages data-id="element-8" />
        <BundleHighlight data-id="element-9" />
        <Suspects data-id="element-10" />
        <HowItWorks data-id="element-11" />
        <Testimonials data-id="element-12" />
        <IncludedFeatures data-id="element-13" />
        <ForYouNotForYou data-id="element-14" />
        <FinalCTA data-id="element-15" />
        <Footer data-id="element-16" />
      </div>
    </div>;
}